import { render, staticRenderFns } from "./CashbackSetting.vue?vue&type=template&id=49bbbc21&"
import script from "./CashbackSetting.vue?vue&type=script&lang=js&"
export * from "./CashbackSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports